<template>
  <div>
    <div v-if="submitting" class="word-submit-container">
      <div class="content">
        <div class="title md:md-title">Thank you</div>
        <div class="status md:md-status">Processing...</div>
        <div class="arc md:md-arc"/>
      </div>
    </div>
    <div v-else class="text-container md:md-text-container">
      <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
        <div class="md:col-span-8">
          <Heading text="Icons for your Happy Place"/>
        </div>
        <div class="md:col-span-8">
          We’re now going to show you icons, generated by artificial intelligence, for some of
          the words you entered.
        </div>
        <div class="md:col-span-8">
          Please choose the icon you feel best represents your words.
        </div>
        <div class="md:col-span-8">
          <Button v-bind:onClick="nextPage" text="Continue"/>
        </div>
      </div>
    </div>
    <audio ref="aud" src="@/assets/audio/word-submit.mp3"/>
  </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';

export default {
  name: 'WordSubmit',
  components: {
    Button,
    Heading,
  },
  data() {
    return {
      submitting: true,
      submitWordsAttempts: 0,
      getIconsAttempts: 0,
    };
  },
  methods: {
    getIcons() {
      this.getIconsAttempts += 1;
      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/api/sessions/session-icon-options/?session=${this.$store.state.sessionId}`)
        .then((response) => {
          const iconData = response.data.icons;
          const iconSets = [];

          for (let i = 0; i < iconData.length; i += 1) {
            const { id, options } = iconData[i];
            const iconSet = {
              id,
              icons: [],
            };

            for (let j = 0; j < options.length; j += 1) {
              if (!iconSet.word) {
                iconSet.word = options[j].word.word;
              }
              iconSet.icons.push({
                id: options[j].id,
                svgPath: `${process.env.VUE_APP_BACKEND_URL}${options[j].svg_file}`,
                pngPath: `${process.env.VUE_APP_BACKEND_URL}${options[j].png_file}`,
              });
            }

            iconSets.push(iconSet);
          }

          this.$store.commit('setIconOptions', iconSets);
          this.showInstruction();
        })
        .catch((error) => {
          if (this.getIconsAttempts < 3) {
            setTimeout(this.getIcons, 2000);
          } else {
            this.$store.commit('setErrorMessage', error);
          }
        });
    },
    nextPage() {
      this.$refs.aud.pause();
      this.$store.commit('setView', 'IconSelect');
    },
    showInstruction() {
      this.$refs.aud.play();
      this.submitting = false;
    },
    submitWords() {
      this.submitWordsAttempts += 1;
      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/api/sessions/submit-words/`,
          {
            uuid: this.$store.state.sessionId,
            words: this.$store.state.words,
          },
        )
        .then(() => {
          this.getIcons();
        })
        .catch((error) => {
          if (this.submitWordsAttempts < 3) {
            setTimeout(this.submitWords, 2000);
          } else {
            this.$store.commit('setErrorMessage', error);
          }
        });
    },
  },
  mounted() {
    this.submitWords();
  },
};
</script>

<style scoped>
.arc {
  animation: rotate 2s infinite linear;
  border: 1px solid #5e5b5c;
  border-radius: 50%;
  border-top-color: transparent;
  height: 25px;
  margin: auto;
  width: 25px;
}

.content {
  align-self: center;
  width: 100%
}

.status {
  padding: 1em 0;
}

.title {
  text-align: center;
}

.word-submit-container {
  align-content: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: auto;
  width: 100vw;
}

@keyframes rotate {
  0%    { transform: rotate(0deg);  }
  100%  { transform: rotate(360deg);  }
}

@responsive {
  .md-arc {
    border-width: 1px;
    height: 37.5px;
    width: 37.5px;
  }

  .md-status {
    font-size: 1em;
  }
}
</style>
